/**
 * Throttle Function
 *
 * @param  {Function} fn - Function to throttle
 * @param  {Integer}  [interval=250] - Throttle interval
 * @param  {Object}   scope - Scope to apply the function
 *
 * @return {Function}
 */
export default (fn, interval = 250, scope) => {
  let last,
      deferTimer;

  return function() {
    const context = scope || this,
          now = +new Date(),
          args = arguments;

    if (last && now < last + interval) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function() {
        last = now;
        fn.apply(context, args);
      }, interval);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};
